import {
  BookOpen,
  Bot,
  Briefcase,
  Calendar,
  Coins,
  FileText,
  LayoutDashboard,
  Receipt,
  Settings,
  Smartphone,
  UserCheck,
  UserCog,
  Users,
  UsersRound,
  UserSquare,
  type LucideIcon,
} from "lucide-react";
import type { GuideModule } from "@/api/guides";

// Display order = suggested learning path.
export const GUIDE_MODULES: { key: GuideModule; icon: LucideIcon }[] = [
  { key: "general_overview", icon: BookOpen },
  { key: "home_dashboard", icon: LayoutDashboard },
  { key: "appointments", icon: Calendar },
  { key: "cases", icon: Briefcase },
  { key: "clients", icon: UsersRound },
  { key: "adversaries", icon: Users },
  { key: "invoicing", icon: FileText },
  { key: "expenses", icon: Receipt },
  { key: "fees", icon: Coins },
  { key: "lawyer_assignment", icon: UserCheck },
  { key: "external_lawyers", icon: UserSquare },
  { key: "team_permissions", icon: UserCog },
  { key: "ai_assistant", icon: Bot },
  { key: "settings", icon: Settings },
  { key: "dossier_mobile", icon: Smartphone },
];

export const getModuleIcon = (key: GuideModule): LucideIcon =>
  GUIDE_MODULES.find((m) => m.key === key)?.icon ?? BookOpen;
